import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "help-box-controls" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["help-box", {hidden: !_ctx.display}]),
    style: _normalizeStyle({top: _ctx.top, left: _ctx.left, right: _ctx.right, bottom: _ctx.bottom, width: _ctx.width, 'z-index': _ctx.zindex})
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getArrowClass(_ctx.arrowPos))
    }, [
      _createElementVNode("div", {
        class: "help-box-text",
        innerHTML: _ctx.content
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          href: "javascript:;",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.disableTips && _ctx.disableTips(...args))),
          class: "margin-around"
        }, _toDisplayString(_ctx.$t("Do not show more tips")), 1),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.understood && _ctx.understood(...args))),
          class: "btn btn-primary btn-sm margin-around"
        }, [
          _hoisted_3,
          _createTextVNode(_toDisplayString(_ctx.$t("Understood")), 1)
        ])
      ])
    ], 2)
  ], 6))
}